/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Message_SellerInputs */

const en_message_seller = /** @type {(inputs: Message_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message Seller`)
};

const es_message_seller = /** @type {(inputs: Message_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje al Vendedor`)
};

const fr_message_seller = /** @type {(inputs: Message_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message au vendeur`)
};

const de_message_seller = /** @type {(inputs: Message_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer kontaktieren`)
};

const id_message_seller = /** @type {(inputs: Message_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Penjual`)
};

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const ja_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const zh_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const ar_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const it_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const ru_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const pt_message_seller = en_message_seller;

/** @type {(inputs: Message_SellerInputs) => LocalizedString} */
const ko_message_seller = en_message_seller;

/**
* | output |
* | --- |
* | "Message Seller" |
*
* @param {Message_SellerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const message_seller = /** @type {((inputs?: Message_SellerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Message_SellerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_message_seller(inputs)
	if (locale === "es") return es_message_seller(inputs)
	if (locale === "fr") return fr_message_seller(inputs)
	if (locale === "de") return de_message_seller(inputs)
	if (locale === "ja") return ja_message_seller(inputs)
	if (locale === "zh") return zh_message_seller(inputs)
	if (locale === "ar") return ar_message_seller(inputs)
	if (locale === "id") return id_message_seller(inputs)
	if (locale === "it") return it_message_seller(inputs)
	if (locale === "ru") return ru_message_seller(inputs)
	if (locale === "pt") return pt_message_seller(inputs)
	return ko_message_seller(inputs)
});